import { render } from "./activities-index.vue?vue&type=template&id=0892452b"
import script from "./activities-index.vue?vue&type=script&lang=js"
export * from "./activities-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__